<template>
  <div class="picking-modal-overlay" @click.self="$emit('close')">
    <div class="picking-modal-box card shadow shipping-modal-box">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0">
            <i class="fas fa-truck-fast me-1 text-success"></i>
            Generar ticket de envío — Remisión #{{ remissionId }}
          </h6>
          <div class="d-flex align-items-center gap-2">
            <button
              v-if="rawResponse"
              type="button"
              class="btn btn-outline-secondary btn-sm mb-0"
              @click="showJson = !showJson"
            >
              <i class="fas fa-code me-1"></i> {{ showJson ? 'Ocultar JSON' : 'Ver JSON' }}
            </button>
            <button type="button" class="btn-close" @click="$emit('close')"></button>
          </div>
        </div>

        <div v-if="showJson" class="shipping-json mb-3">
          <pre>{{ rawResponse }}</pre>
        </div>

        <div class="row g-3">
          <!-- Izquierda: ubicación del cliente tal como está en el pedido -->
          <div class="col-lg-5">
            <div class="card shipping-card h-100">
              <div class="card-header shipping-card-header">
                <i class="fas fa-location-dot me-1"></i> Ubicación del cliente
              </div>
              <div class="card-body pt-2">
                <dl class="shipping-info-list mb-0">
                  <dt>Nombre</dt>
                  <dd>{{ remission.name || '—' }}</dd>
                  <dt>Documento</dt>
                  <dd>{{ remission.document_type || '' }} {{ remission.document || '—' }}</dd>
                  <dt>Teléfono</dt>
                  <dd>{{ remission.phone || '—' }}</dd>
                  <dt>Correo</dt>
                  <dd>{{ remission.email || '—' }}</dd>
                  <dt>Dirección</dt>
                  <dd>{{ remission.address || '—' }}</dd>
                  <dt>Departamento</dt>
                  <dd>{{ remission.departamento || '—' }}</dd>
                  <dt>Ciudad</dt>
                  <dd>{{ remission.municipio || '—' }}</dd>
                  <dt>Código postal</dt>
                  <dd>{{ remission.codigo_postal || '—' }}</dd>
                  <template v-if="remission.observation">
                    <dt>Observación</dt>
                    <dd>{{ remission.observation }}</dd>
                  </template>
                </dl>

                <div
                  class="shipping-dane-status mt-3"
                  :class="originalDane ? 'shipping-dane-status--ok' : 'shipping-dane-status--warn'"
                >
                  <template v-if="originalDane">
                    <i class="fas fa-circle-check me-1"></i>
                    Ciudad reconocida · DANE <b>{{ originalDane }}</b>
                  </template>
                  <template v-else>
                    <i class="fas fa-triangle-exclamation me-1"></i>
                    No se pudo reconocer la ciudad del pedido. Selecciónala a la derecha.
                  </template>
                </div>
              </div>
            </div>
          </div>

          <!-- Derecha: datos que se enviarán a ConEnvíos (editables) -->
          <div class="col-lg-7">
            <div class="card shipping-card h-100">
              <div class="card-header shipping-card-header">
                <i class="fas fa-paper-plane me-1"></i> Información a enviar a ConEnvíos
              </div>
              <div class="card-body pt-2">
                <div class="row g-2">
                  <div class="col-md-12">
                    <label class="form-control-label text-xs">Nombre destinatario</label>
                    <input v-model.trim="form.name" type="text" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label text-xs">Tipo doc.</label>
                    <select v-model="form.document_type" class="form-control form-control-sm">
                      <option value="CC">CC</option>
                      <option value="NIT">NIT</option>
                      <option value="CE">CE</option>
                      <option value="PP">Pasaporte</option>
                      <option value="TI">TI</option>
                    </select>
                  </div>
                  <div class="col-md-8">
                    <label class="form-control-label text-xs">Número documento</label>
                    <input v-model.trim="form.document_number" type="text" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label text-xs">Teléfono</label>
                    <input v-model.trim="form.phone" type="text" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label text-xs">Correo</label>
                    <input v-model.trim="form.email" type="email" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label text-xs">Departamento</label>
                    <select v-model="form.department" class="form-control form-control-sm">
                      <option value="">Selecciona...</option>
                      <option v-for="dpto in departments" :key="dpto" :value="dpto">{{ dpto }}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label text-xs">Ciudad</label>
                    <select
                      v-model="form.city_dane"
                      class="form-control form-control-sm"
                      :disabled="!form.department"
                    >
                      <option value="">Selecciona...</option>
                      <option v-for="c in citiesOfDepartment" :key="c.codigo_dane" :value="c.codigo_dane">
                        {{ c.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-8">
                    <label class="form-control-label text-xs">Dirección</label>
                    <input v-model.trim="form.street" type="text" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label text-xs">Barrio</label>
                    <input v-model.trim="form.neighborhood" type="text" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-12">
                    <label class="form-control-label text-xs">Contenido del paquete</label>
                    <input v-model.trim="form.description" type="text" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label text-xs">Peso (kg)</label>
                    <input v-model.number="form.weight" type="number" min="0.1" step="0.1" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label text-xs">Largo (cm)</label>
                    <input v-model.number="form.length" type="number" min="1" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label text-xs">Ancho (cm)</label>
                    <input v-model.number="form.width" type="number" min="1" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label text-xs">Alto (cm)</label>
                    <input v-model.number="form.height" type="number" min="1" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label text-xs">Valor declarado</label>
                    <input v-model.number="form.declared_value" type="number" min="0" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label text-xs">Método de pago</label>
                    <select v-model="form.payment_method" class="form-control form-control-sm">
                      <option value="">Flete pago</option>
                      <option value="Contraentrega">Contraentrega + Flete</option>
                      <option value="Flete Contraentrega">Flete Contraentrega</option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <div class="form-check mb-0">
                      <input
                        id="chargeShipping"
                        v-model="form.charge_to_customer"
                        type="checkbox"
                        class="form-check-input"
                      />
                      <label class="form-check-label text-xs" for="chargeShipping">
                        Cobrar envío al cliente
                      </label>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    class="btn btn-success btn-sm mb-0"
                    :disabled="loading || !form.city_dane"
                    @click="calculate"
                  >
                    <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-calculator'"></i>
                    {{ loading ? 'Cotizando...' : 'Cotizar' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Transportadoras cotizadas -->
        <div class="mt-4">
          <h6 class="text-sm mb-2">
            <i class="fas fa-truck me-1"></i> Transportadoras
          </h6>

          <div v-if="loading" class="text-center py-4">
            <i class="fas fa-spinner fa-spin fa-2x text-success"></i>
            <p class="mt-2 text-sm text-secondary">Calculando opciones de envío...</p>
          </div>

          <div v-else-if="error" class="text-center py-3">
            <i class="fas fa-triangle-exclamation fa-2x text-warning"></i>
            <p class="mt-2 text-sm text-secondary">{{ error }}</p>
          </div>

          <div v-else-if="!quoted" class="shipping-empty text-center py-4 text-sm text-secondary">
            Revisa la información y presiona <b>Cotizar</b> para ver las transportadoras disponibles.
          </div>

          <div v-else-if="options.length === 0" class="shipping-empty text-center py-4 text-sm text-secondary">
            No se encontraron opciones de envío para este destino.
          </div>

          <div v-else class="shipping-carriers-grid">
            <div
              v-for="(option, index) in options"
              :key="index"
              class="shipping-carrier-card"
              :class="{ 'shipping-carrier-card--selected': selectedIndex === index }"
              @click="selectedIndex = index"
            >
              <i
                v-if="selectedIndex === index"
                class="fas fa-circle-check shipping-carrier-check"
              ></i>
              <div class="shipping-carrier-logo">
                <img
                  v-if="carrierInfo(option).image"
                  :src="carrierInfo(option).image"
                  :alt="carrierInfo(option).name"
                  class="shipping-carrier-img"
                />
                <i v-else class="fas fa-truck-fast fa-lg text-secondary"></i>
              </div>
              <div class="shipping-carrier-name">{{ carrierInfo(option).name }}</div>
              <div class="text-xs text-secondary">{{ deliveryDaysLabel(option) }}</div>
              <div class="shipping-carrier-price">{{ formatPrice(option.price ?? option.total) }}</div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4">
          <button type="button" class="btn btn-secondary btn-sm mb-0" @click="$emit('close')">
            <i class="fas fa-times me-1"></i> Cerrar
          </button>
          <button
            type="button"
            class="btn btn-success btn-sm mb-0"
            :disabled="selectedIndex === null || generating"
            @click="generateWaybill"
          >
            <i class="fas" :class="generating ? 'fa-spinner fa-spin' : 'fa-barcode'"></i>
            {{ generating ? 'Generando...' : 'Generar guía' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import shippingService from '@/services/shipping.service';
import citiesJson from '@/assets/data/ciudades.json';
import { resolveCityDane, isRestrictedCity } from '@/utils/daneCities';

// Ciudad de origen fija del envío (Cúcuta, código DANE 8 dígitos)
const SENDER_CITY = '54001000';
const SENDER_STATE = '54';

const CITIES = (citiesJson || []).filter((c) => c.activo !== false);

export default {
  name: 'ShippingModal',
  props: {
    remission: { type: Object, required: true },
  },
  emits: ['close', 'generated'],
  data() {
    return {
      loading: false,
      quoted: false,
      error: '',
      options: [],
      selectedIndex: null,
      generating: false,
      showJson: false,
      rawResponse: '',
      originalDane: '',
      carriersMap: {},
      form: {
        name: '',
        document_type: 'CC',
        document_number: '',
        phone: '',
        email: '',
        department: '',
        city_dane: '',
        street: '',
        neighborhood: '',
        description: '',
        weight: 0.2,
        length: 1,
        width: 1,
        height: 1,
        declared_value: 0,
        payment_method: '',
        charge_to_customer: true,
      },
    };
  },
  computed: {
    remissionId() {
      return this.remission?.id;
    },
    orderLabel() {
      return `#${this.remission?.id}`;
    },
    departments() {
      const set = new Set(CITIES.map((c) => c.dpto));
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es'));
    },
    citiesOfDepartment() {
      if (!this.form.department) return [];
      return CITIES
        .filter((c) => c.dpto === this.form.department)
        .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'));
    },
    // Cualquier cambio en lo que afecta la cotización invalida la anterior
    quoteKey() {
      const f = this.form;
      return [f.city_dane, f.weight, f.length, f.width, f.height,
        f.declared_value, f.payment_method, f.charge_to_customer].join('|');
    },
  },
  watch: {
    'form.department'() {
      const stillValid = this.citiesOfDepartment.some((c) => c.codigo_dane === this.form.city_dane);
      if (!stillValid) this.form.city_dane = '';
    },
    quoteKey() {
      this.resetQuote();
    },
  },
  mounted() {
    this.loadCarriers();
    this.fillForm();
  },
  methods: {
    async loadCarriers() {
      // Respaldo para resolver logo/nombre de transportadora por carrier_id
      try {
        const res = await shippingService.getCarriers();
        const list = res.data?.data || [];
        const map = {};
        list.forEach((c) => {
          if (c.carrier_id) map[c.carrier_id] = c;
        });
        this.carriersMap = map;
      } catch (err) {
        console.error('Error al cargar transportadoras:', err);
      }
    },
    /**
     * Resuelve el logo y el nombre legible de la transportadora de una opción,
     * igualando el carrier_id con la tabla carriers cuando el API no trae
     * el nombre o trae el id en su lugar.
     */
    carrierInfo(option) {
      // Id de transportadora de ConEnvios: ObjectId de Mongo (24 hex)
      const ID_RE = /^[0-9a-f]{24}$/i;

      let id = option.carrier_id
        || option.carrierId
        || option.carrier?.id
        || option.carrier?._id
        || (typeof option.carrier === 'string' ? option.carrier : '')
        || '';

      let name = option.carrier_name
        || option.carrier?.name
        || option.name
        || '';

      // El API a veces trae el id como "nombre"
      if (!id && ID_RE.test(String(name).trim())) {
        id = String(name).trim();
      }
      if (ID_RE.test(String(name).trim())) {
        name = '';
      }

      const known = this.carriersMap[id] || null;

      if (!name || name === id) {
        name = known?.name || 'Transportadora';
      }

      const image = option.carrier_image
        || option.carrier?.image_url
        || option.carrier?.logo
        || known?.image_url
        || '';

      return { id, name, image };
    },
    fillForm() {
      const r = this.remission || {};
      const items = r.details || [];

      this.originalDane = resolveCityDane(r.municipio, r.departamento, '', r.codigo_postal);
      const city = CITIES.find((c) => c.codigo_dane === this.originalDane);

      this.form = {
        ...this.form,
        name: r.name || '',
        document_type: r.document_type || 'CC',
        document_number: r.document || '',
        phone: r.phone || '',
        email: r.email || '',
        department: city?.dpto || '',
        city_dane: city?.codigo_dane || '',
        street: r.address || '',
        description: items
          .map((d) => d.inventory?.name || d.model?.name || 'Producto')
          .join(', ') || 'Productos',
        declared_value: parseFloat(r.grand_total ?? r.total ?? 0) || 0,
      };
    },
    resetQuote() {
      this.quoted = false;
      this.options = [];
      this.selectedIndex = null;
      this.error = '';
    },
    buildPackageDetail() {
      const f = this.form;
      return [{
        type: 'Box',
        package_number: '',
        description: f.description || 'Productos',
        weight: parseFloat(f.weight) || 0.2,
        quantity: 1,
        price: parseFloat(f.declared_value) || 0,
        dimensions: {
          length: parseFloat(f.length) || 1,
          width: parseFloat(f.width) || 1,
          height: parseFloat(f.height) || 1,
        },
      }];
    },
    async calculate() {
      if (!this.form.city_dane) return;

      if (isRestrictedCity(this.form.city_dane)) {
        await Swal.fire({
          icon: 'warning',
          title: 'Ciudad de destino no permitida',
          text: 'El destino es la misma ciudad de origen del envío (Cúcuta y área metropolitana). No se puede generar la guía.',
          customClass: { container: 'swal-high-z' },
        });
        return;
      }

      this.loading = true;
      this.resetQuote();
      try {
        const payload = {
          order_id: this.orderId(),
          sender_city: SENDER_CITY,
          recipient_city: this.form.city_dane,
          package_detail: this.buildPackageDetail(),
          charge_shipping_to_customer: this.form.charge_to_customer,
          payment_method: this.form.payment_method,
          package_type: 'Paquetes',
          notes: this.orderLabel,
          external_id: `lbp-${this.orderLabel}`,
        };
        const res = await shippingService.calculateShipping(payload);
        this.options = res.data?.data || [];
        this.rawResponse = JSON.stringify(res.data, null, 2);
        this.quoted = true;
      } catch (err) {
        console.error('Error al calcular el envío:', err);
        this.error = err.response?.data?.message || 'No se pudieron calcular las opciones de envío.';
      } finally {
        this.loading = false;
      }
    },
    orderId() {
      // Id interno de la remisión (referencia del pedido para ConEnvios)
      return this.remission?.id;
    },
    deliveryDaysLabel(option) {
      const days = option.delivery_days ?? option.delivery_time ?? option.eta;
      if (days === undefined || days === null || days === '') return '—';
      return `${days} ${String(days) === '1' ? 'día' : 'días'}`;
    },
    formatPrice(value) {
      const n = parseFloat(value || 0);
      return `$${n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    },
    async generateWaybill() {
      if (this.selectedIndex === null) return;
      const option = this.options[this.selectedIndex];
      const f = this.form;

      const missing = [];
      if (!f.name) missing.push('nombre');
      if (!f.phone) missing.push('teléfono');
      if (!f.street) missing.push('dirección');
      if (missing.length) {
        await Swal.fire({
          icon: 'warning',
          title: 'Faltan datos',
          text: `Completa: ${missing.join(', ')}.`,
          customClass: { container: 'swal-high-z' },
        });
        return;
      }

      const payload = {
        order_id: this.orderId(),
        sender: {
          address: {
            street: '', // la dirección de origen se resuelve en el backend (configurable)
            city: SENDER_CITY,
            neighborhood: '',
            state: SENDER_STATE,
            country: 'CO',
          },
        },
        receiver: {
          name: f.name,
          address: {
            street: f.street,
            city: f.city_dane,
            neighborhood: f.neighborhood,
            state: String(f.city_dane).substring(0, 2),
            country: 'CO',
          },
          email: f.email,
          document_type: f.document_type || 'CC',
          document_number: f.document_number || '10000000',
          phone: f.phone,
        },
        package_type: 'Paquetes',
        package_details: this.buildPackageDetail(),
        payment_method: f.payment_method,
        status: 'Aceptado',
        charge_shipping_to_customer: f.charge_to_customer,
        notes: this.orderLabel,
        external_id: `lbp-${this.orderLabel}`,
        carrier_id: this.carrierInfo(option).id || undefined,
        shipping_method: this.carrierInfo(option).id || undefined,
        shipping_cost: option.price ?? option.total ?? 0,
      };

      this.generating = true;
      try {
        const res = await shippingService.generateWaybill(payload);
        const waybillResponse = res.data?.data || {};

        // Guardar el response en la orden para re-imprimir después
        this.$emit('generated', waybillResponse);

        await Swal.fire({
          icon: 'success',
          title: 'Guía generada',
          text: `Guía ${waybillResponse.id || waybillResponse.data?.id || ''} creada correctamente.`,
          timer: 2500,
          showConfirmButton: false,
          customClass: { container: 'swal-high-z' },
        });
        this.$emit('close');
      } catch (err) {
        console.error('Error al generar la guía:', err);
        // El pedido ya tenía guía: se carga la existente para poder imprimir el rótulo
        if (err.response?.status === 409 && err.response.data?.data) {
          this.$emit('generated', err.response.data.data);
        }
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.response?.data?.message || 'No se pudo generar la guía de envío.',
          customClass: { container: 'swal-high-z' },
        });
      } finally {
        this.generating = false;
      }
    },
  },
};
</script>

<style scoped>
/* Overlay y caja del modal (mismas clases que usa el picking) */
.picking-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.picking-modal-box {
  width: 100%;
}

.shipping-modal-box {
  width: 1200px;
  max-width: 96vw;
  max-height: 92vh;
  overflow-y: auto;
}

.shipping-json {
  max-height: 200px;
  overflow-y: auto;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 8px;
}

.shipping-json pre {
  margin: 0;
  font-size: 11px;
  white-space: pre-wrap;
  word-break: break-word;
}

.shipping-card {
  border: 1px solid #e9ecef;
  box-shadow: none;
}

.shipping-card-header {
  background: #f8f9fa;
  padding: 0.6rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e9ecef;
}

.shipping-info-list {
  display: grid;
  grid-template-columns: 110px 1fr;
  row-gap: 0.4rem;
  column-gap: 0.75rem;
  font-size: 0.85rem;
}

.shipping-info-list dt {
  font-weight: 600;
  color: #8392ab;
  font-size: 0.75rem;
  align-self: center;
}

.shipping-info-list dd {
  margin: 0;
  word-break: break-word;
}

.shipping-dane-status {
  font-size: 0.78rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
}

.shipping-dane-status--ok {
  background: #e8f5e9;
  color: #1b7a4b;
}

.shipping-dane-status--warn {
  background: #fff4e5;
  color: #b26a00;
}

.shipping-empty {
  border: 1px dashed #dee2e6;
  border-radius: 8px;
}

.shipping-carriers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 0.75rem;
}

.shipping-carrier-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  padding: 0.9rem 0.75rem;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.shipping-carrier-card:hover {
  border-color: #b8e9d1;
  background: #f6fbf8;
}

.shipping-carrier-card--selected {
  border-color: #2dce89;
  background: #e8f5e9;
  box-shadow: 0 0 0 2px rgba(45, 206, 137, 0.25);
}

.shipping-carrier-check {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #2dce89;
}

.shipping-carrier-logo {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shipping-carrier-img {
  max-height: 34px;
  max-width: 110px;
  object-fit: contain;
}

.shipping-carrier-name {
  font-weight: 600;
  font-size: 0.85rem;
}

.shipping-carrier-price {
  font-weight: 700;
  font-size: 0.95rem;
}
</style>

<!-- Global: SweetAlert2 se teletransporta al body, necesita z-index sobre el modal -->
<style>
.swal-high-z {
  z-index: 20000 !important;
}
</style>
